import styled from "styled-components";

export const Container = styled.section`
  margin-top: 12rem;

  h2{
    display: inline-block;
    margin-bottom: 3rem;
    font-size: 3rem;
    color: var(--green);
  }

  .timeline{
    border-left: 2px solid rgba(35, 206, 107, 0.4);
    margin-left: 0.8rem;
    display: flex;
    flex-direction: column;
    gap: 2.4rem;
  }

  .job{
    position: relative;
    margin-left: 2.4rem;
    padding: 2rem 2.4rem;
    background-color: #2b2b2b;
    border-radius: 1.2rem;
    color: #fff;
    transition: transform 0.25s, box-shadow 0.25s;

    &:hover{
      transform: translateY(-4px);
      box-shadow: 0 8px 22px rgba(35, 206, 107, 0.18);
    }

    .dot{
      position: absolute;
      left: -3.3rem;
      top: 2.6rem;
      width: 1.4rem;
      height: 1.4rem;
      border-radius: 50%;
      background-color: var(--green);
      box-shadow: 0 0 0 0.4rem rgba(35, 206, 107, 0.25);
    }

    header{
      display: flex;
      flex-wrap: wrap;
      align-items: baseline;
      justify-content: space-between;
      gap: 0.6rem 2rem;
    }

    h3{
      font-size: 2.2rem;
      color: var(--green);
    }

    .period{
      font-size: 1.4rem;
      color: #5eb8ff;
      font-weight: 600;
    }

    .company{
      margin: 0.6rem 0 1.2rem;
      font-size: 1.7rem;
      font-weight: 600;

      .location{
        margin-left: 0.8rem;
        font-size: 1.4rem;
        font-weight: 400;
        opacity: 0.65;
      }
    }

    ul{
      display: flex;
      flex-direction: column;
      gap: 0.8rem;
    }

    li{
      position: relative;
      padding-left: 1.8rem;
      font-size: 1.5rem;
      line-height: 1.6;
      letter-spacing: 0.05rem;

      &::before{
        content: "";
        position: absolute;
        left: 0;
        top: 0.8rem;
        width: 0.6rem;
        height: 0.6rem;
        border-radius: 50%;
        background-color: #ffd54f;
      }
    }
  }

  .extras{
    margin-top: 4rem;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;

    > *{
      min-width: 0;
    }
  }

  .card{
    position: relative;
    height: 100%;
    padding: 2rem 2.2rem;
    background-color: #2b2b2b;
    border-radius: 1.2rem;
    color: #fff;
    outline: none;
    transition: transform 0.25s, box-shadow 0.25s;

    &:hover{
      transform: translateY(-4px);
      box-shadow: 0 8px 22px rgba(35, 206, 107, 0.18);
    }

    h4{
      font-size: 1.2rem;
      text-transform: uppercase;
      letter-spacing: 0.2rem;
      color: #ff8a65;
      margin-bottom: 1rem;
    }

    h3{
      font-size: 1.9rem;
      color: var(--green);
      margin-bottom: 0.8rem;
    }

    p{
      font-size: 1.5rem;
      line-height: 1.6;
      letter-spacing: 0.05rem;
      margin-bottom: 1rem;
    }

    .period{
      display: block;
      font-size: 1.4rem;
      color: #5eb8ff;
      font-weight: 600;
    }
  }

  .languages{
    display: flex;
    flex-direction: column;
    gap: 1.2rem;

    li{
      display: flex;
      flex-direction: column;
      gap: 0.2rem;
    }

    strong{
      font-size: 1.6rem;
      color: var(--green);
    }

    span{
      font-size: 1.4rem;
      opacity: 0.8;
    }
  }

  .cert{
    cursor: default;

    .verify{
      display: inline-block;
      margin-top: 1.2rem;
      font-size: 1.4rem;
      font-weight: 600;
      color: var(--green);
      border-bottom: 1px solid var(--green);
      transition: color 0.25s, border-color 0.25s;

      &:hover{
        color: #fff;
        border-color: #fff;
      }
    }

    .hint{
      display: block;
      margin-top: 1rem;
      font-size: 1.2rem;
      color: #ffd54f;
    }

  }

  @media (max-width: 960px){
    .extras{
      grid-template-columns: 1fr;
    }
  }

  @media (max-width: 480px){
    .job{
      margin-left: 1.8rem;
      padding: 1.6rem 1.4rem;

      .dot{
        left: -2.7rem;
      }

      h3{
        font-size: 1.9rem;
      }
    }
  }
`

// Rendered outside the section (through a portal) so it centers on the screen,
// not inside the card it belongs to.
export const CertificatePreview = styled.div<{ $open: boolean }>`
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background-color: rgba(0, 0, 0, 0.6);
  opacity: ${({ $open }) => ($open ? 1 : 0)};
  visibility: ${({ $open }) => ($open ? "visible" : "hidden")};
  pointer-events: none;
  transition: opacity 0.25s, visibility 0.25s;

  img{
    max-width: min(90rem, 94vw);
    max-height: 88vh;
    padding: 0.8rem;
    border-radius: 1.2rem;
    background-color: #fff;
    box-shadow: 0 16px 48px rgba(0, 0, 0, 0.55);
    transform: scale(${({ $open }) => ($open ? 1 : 0.96)});
    transition: transform 0.25s;
  }
`
